<template>
  <div class="timeline">
    <div class="timeline-title">Timelines</div>
    <Timeline :value="timeline">
      <template #marker>
        <StepMarker />
      </template>

      <template #content="slotProps">
        <div class="timeline-item-title">
          {{ slotProps.item.title }}
        </div>
        <div class="timeline-item-description">
          {{ slotProps.item.description }}
        </div>
      </template>
    </Timeline>
  </div>
</template>

<script setup>
import {computed} from "vue";
import StepMarker from "./StepMarker";

const props = defineProps({
  data: {type: Array, required: true, default: []}
})

const timeline = computed(() => {
  return props.data?.map((timeline) => ({
    title: getDate(timeline),
    description: timeline.type.label
  }));
})

const getDate = ({start_date, end_date}) => {
  return start_date.isSame(end_date, 'day')
    ? start_date.format('MMMM DD')
    : `${start_date.format('MMMM DD')} - ${end_date.format('MMMM DD')}`
}

</script>

<style lang="scss" scoped>
@import "../assets/sass/theme_variables";

.timeline {
  width: toRem(320);
}

.timeline-title {
  margin-bottom: toRem(32);
  font-size: toRem(20);
  font-weight: bold;
}

::v-deep(.p-timeline) {
  .p-timeline-event-opposite {
    display: none;
  }

  .p-timeline-event {
    min-height: toRem(110);
  }
}

.timeline-item-marker {
  position: relative;
  width: toRem(24);
  height: toRem(24);
  background: #DFE0E6;
  border-radius: 50%;

  &:after {
    position: absolute;
    left: 50%;
    top: 50%;
    width: toRem(6);
    height: toRem(6);
    transform: translate(-50%, -50%);
    background: $bgBlocks;
    content: '';
  }
}

.timeline-item-title {
  font-weight: 600;
  margin-bottom: toRem(4);
}
</style>
